import script from "./IncomingCallModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomingCallModal.vue?vue&type=script&setup=true&lang=js"

import "./IncomingCallModal.vue?vue&type=style&index=0&id=edc1c624&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edc1c624"]])

export default __exports__